import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ModalWrapper } from "@msuite/ui/modal";
import React from "react";
import { Can } from "@/components/citadel";
import { ConnectPartnerModal } from "@/modals/partners/connect-partner-modal";

export function PartnersMenu() {
	/** Hooks */
	const { t } = useTranslation();
	const connectPartnerModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<Can
				action="create"
				subject="Partner"
			>
				<Button
					icon={<Icon name="Plus" />}
					variant="primary"
					onClick={connectPartnerModal.onOpen}
					data-cy="partners-connect-partner-button"
				>
					{t("organization.connect_organization")}
				</Button>
			</Can>
			<ModalWrapper>
				{connectPartnerModal.isOpen && (
					<ConnectPartnerModal
						isOpen={connectPartnerModal.isOpen}
						onClose={connectPartnerModal.onClose}
					/>
				)}
			</ModalWrapper>
		</React.Fragment>
	);
}
